import type { ShipmentContract, ShipmentRequest } from '../types/marketplace';

export interface CargoInsuranceEntityState {
    selectedRequest: ShipmentRequest | null;
    myRequests: ShipmentRequest[];
    feedRequests: ShipmentRequest[];
    selectedContract: ShipmentContract | null;
    myContracts: ShipmentContract[];
}

function synchronizeContractRequest(
    contract: ShipmentContract,
    request: ShipmentRequest,
): ShipmentContract {
    if (contract.shipment_request_id !== request.id) {
        return contract;
    }

    return {
        ...contract,
        cargo_insurance: request.cargo_insurance,
        request: contract.request ? request : contract.request,
    };
}

export function synchronizeCargoInsuranceEntities(
    state: CargoInsuranceEntityState,
    request: ShipmentRequest,
): CargoInsuranceEntityState {
    return {
        selectedRequest: state.selectedRequest?.id === request.id ? request : state.selectedRequest,
        myRequests: state.myRequests.map((item) => (item.id === request.id ? request : item)),
        feedRequests: state.feedRequests.map((item) => (item.id === request.id ? request : item)),
        selectedContract: state.selectedContract
            ? synchronizeContractRequest(state.selectedContract, request)
            : null,
        myContracts: state.myContracts.map((contract) => synchronizeContractRequest(contract, request)),
    };
}
